import {
  HDFCIcon,
  AxisIcon,
  ICICIIcon,
  SBIIcon,
  SIBIcon,
  KotakIcon,
} from '../presentation/components/icons';
import type React from 'react';

export interface PopularBankItem {
  code: string;
  name: string;
  Icon: React.FC<React.SVGProps<SVGSVGElement>>;
}

export interface BankItem {
  code: string;
  name: string;
}

export const POPULAR_BANKS: PopularBankItem[] = [
  { code: 'HDFC', name: 'HDFC', Icon: HDFCIcon },
  { code: 'SBIN', name: 'SBI', Icon: SBIIcon },
  { code: 'ICIC', name: 'ICICI', Icon: ICICIIcon },
  { code: 'KKBK', name: 'Kotak', Icon: KotakIcon },
  { code: 'SIBL', name: 'SIB', Icon: SIBIcon },
  { code: 'UTIB', name: 'Axis', Icon: AxisIcon },
];
